(function () {
  'use strict';

  function initPdp(root) {
    var currency = root.dataset.currency || 'CAD';
    var currentCoverage = Number(root.dataset.coverage) || 8;
    var requestedControllerCapacity = Number(root.dataset.controllerCapacity);
    var controllerCapacity = isFinite(requestedControllerCapacity) && requestedControllerCapacity > 0
      ? Math.max(1, Math.floor(requestedControllerCapacity))
      : 30;
    var currentPriceCents = Number(root.dataset.currentPrice) || 0;
    var currentVariantTitle = '';
    var recommendedPanels = 1;
    var form = root.querySelector('[data-pdp3-form]');
    var variantInput = root.querySelector('[data-pdp3-variant-input]');
    var quantityInput = root.querySelector('[data-pdp3-quantity-input]');
    var addButton = root.querySelector('[data-pdp3-add]');
    var addLabel = root.querySelector('[data-pdp3-add-label]');
    var addPrice = root.querySelector('[data-pdp3-add-price]');
    var selectedOption = root.querySelector('[data-pdp3-selected-option]');
    var mobileTitle = root.querySelector('[data-pdp3-mobile-title]');
    var mobilePrice = root.querySelector('[data-pdp3-mobile-price]');
    var variantButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pdp3-variant-button]'));
    var visibleQuantity = root.querySelector('[data-pdp3-visible-quantity]');
    var controllerOptions = Array.prototype.slice.call(root.querySelectorAll('[data-pdp3-controller-option]'));
    var controllerSummaryElement = root.querySelector('[data-pdp3-controller-summary]');
    var controllerQuantityLabel = root.querySelector('[data-pdp3-controller-quantity]');
    var panelQuantityLabel = root.querySelector('[data-pdp3-panel-quantity]');
    var controllerCapacityLabel = root.querySelector('[data-pdp3-controller-capacity]');
    var controllerOnly = root.dataset.controllerOnly === 'true';
    var controllerPriceCents = Number(root.dataset.controllerPrice) || 0;
    var controllerVariantId = root.dataset.controllerVariantId || '';
    var controllerAvailable = root.dataset.controllerAvailable !== 'false';
    var currentAvailable = root.dataset.currentAvailable !== 'false';
    var cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var roomKit = root.dataset.roomKit === 'true';
    var panel2x2Handle = root.dataset.panel2x2Handle || 'star-light-ceiling-panel';
    var panel2x2VariantId = root.dataset.panel2x2VariantId || '';
    var panel2x2PriceCents = Number(root.dataset.panel2x2Price) || 0;
    var panel2x2Available = root.dataset.panel2x2Available === 'true';
    var panel2x4Handle = root.dataset.panel2x4Handle || 'starlight-ceiling-2x4-ft-panel';
    var panel2x4VariantId = root.dataset.panel2x4VariantId || '';
    var panel2x4PriceCents = Number(root.dataset.panel2x4Price) || 0;
    var panel2x4Available = root.dataset.panel2x4Available === 'true';
    var roomKitProductsLoading = false;
    var kitVariantSelect = root.querySelector('[data-pdp3-kit-variant]');
    var kitPanelTotal = root.querySelector('[data-pdp3-kit-panel-total]');
    var kitControllerCount = root.querySelector('[data-pdp3-kit-controller-count]');
    var kitPanelDetail = root.querySelector('[data-pdp3-kit-panel-detail]');
    var kitDiagram = root.querySelector('[data-pdp3-kit-diagram]');
    var roomKitPlan = null;

    function moveBreadPayBlock() {
      var anchor = root.querySelector('[data-pdp3-breadpay-anchor]');
      if (!anchor) return false;

      var breadBlock = document.querySelector('[id*="bread_pay_messaging_app_block_product"]');
      if (!breadBlock) {
        var appBlocks = Array.prototype.slice.call(document.querySelectorAll('.shopify-app-block, .shopify-block'));
        breadBlock = appBlocks.find(function (block) {
          return /bread\s*pay/i.test(block.id || '') || /bread\s*pay/i.test(block.textContent || '');
        });
      }
      if (!breadBlock || anchor.contains(breadBlock)) return Boolean(breadBlock);

      anchor.appendChild(breadBlock);
      return true;
    }

    if (!moveBreadPayBlock()) {
      var breadObserver = new MutationObserver(function () {
        if (moveBreadPayBlock()) breadObserver.disconnect();
      });
      breadObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { breadObserver.disconnect(); }, 10000);
    }

    function publishTracking(eventName, eventData, dedupeKey) {
      if (!window.StarlightTracking) return;
      window.StarlightTracking.once(eventName, eventData, dedupeKey);
    }

    function trackBuilderStarted(builderType) {
      publishTracking(
        'starlight:room_builder_started',
        { builder_type: builderType },
        window.location.pathname + ':' + builderType + ':started'
      );
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '$' + ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency;
      }
    }

    function formattedSize(coverage) {
      return coverage === 4 ? "2' by 2'" : "2' by 4'";
    }

    function updatePurchaseTotal() {
      if (roomKit) {
        var kitOption = kitVariantSelect && kitVariantSelect.options[kitVariantSelect.selectedIndex];
        if (!kitOption) return;
        currentPriceCents = Number(kitOption.dataset.variantPrice) || 0;
        currentAvailable = kitOption.dataset.variantAvailable === 'true';
        if (variantInput) variantInput.value = kitOption.value;
        root.querySelectorAll('[data-pdp3-price]').forEach(function (element) { element.textContent = money(currentPriceCents); });
        if (addPrice) addPrice.textContent = money(currentPriceCents);
        if (mobilePrice) mobilePrice.textContent = money(currentPriceCents);
        if (addButton) addButton.disabled = !currentAvailable;
        if (addLabel) addLabel.textContent = currentAvailable ? 'Add room kit to cart' : 'Unavailable';
        var kitMobileAdd = root.querySelector('[data-pdp3-mobile-add]');
        if (kitMobileAdd) kitMobileAdd.disabled = !currentAvailable;
        return;
      }
      var quantity = Math.max(1, Math.min(99, Math.round(Number(visibleQuantity && visibleQuantity.value) || 1)));
      if (visibleQuantity) visibleQuantity.value = String(quantity);
      if (quantityInput) quantityInput.value = String(quantity);
      var controllerSelected = !controllerOnly && controllerOptions.some(function (option) { return option.value === 'controller' && option.checked; });
      var controllerCount = controllerSelected ? Math.ceil(quantity / controllerCapacity) : 0;
      var total = (currentPriceCents * quantity) + (controllerPriceCents * controllerCount);
      if (addPrice) addPrice.textContent = money(total);
      if (mobilePrice) mobilePrice.textContent = money(total);
      if (controllerSummaryElement) controllerSummaryElement.hidden = !controllerSelected;
      if (controllerQuantityLabel) {
        controllerQuantityLabel.textContent = controllerCount + ' controller' + (controllerCount === 1 ? '' : 's');
      }
      if (panelQuantityLabel) {
        panelQuantityLabel.textContent = quantity + ' panel' + (quantity === 1 ? '' : 's');
      }
      if (controllerCapacityLabel) controllerCapacityLabel.textContent = String(controllerCapacity);
      if (addButton) addButton.disabled = !currentAvailable || (controllerSelected && (!controllerVariantId || !controllerAvailable));
    }

    function loadRoomKitProducts() {
      if (!roomKit || !roomKitProductsLoading) return Promise.resolve();
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';

      function loadProduct(handle, preferredVariantTitle) {
        return fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Product load failed');
          return response.json();
        }).then(function (productData) {
          var variants = Array.isArray(productData.variants) ? productData.variants : [];
          var preferredTitle = String(preferredVariantTitle || '').toLowerCase();
          return variants.find(function (variant) {
            return String(variant.title || '').toLowerCase() === preferredTitle;
          }) || variants.find(function (variant) { return variant.available; }) || variants[0];
        });
      }

      return Promise.all([
        loadProduct(panel2x2Handle, 'none'),
        loadProduct(panel2x4Handle, 'default title')
      ]).then(function (variants) {
        var panel2x2 = variants[0];
        var panel2x4 = variants[1];
        if (!panel2x2 || !panel2x4) throw new Error('Panel variant missing');
        panel2x2VariantId = String(panel2x2.id);
        panel2x2PriceCents = Number(panel2x2.price) || 0;
        panel2x2Available = panel2x2.available === true;
        panel2x4VariantId = String(panel2x4.id);
        panel2x4PriceCents = Number(panel2x4.price) || 0;
        panel2x4Available = panel2x4.available === true;
        roomKitProductsLoading = false;
        root.dataset.panel2x2VariantId = panel2x2VariantId;
        root.dataset.panel2x2Price = String(panel2x2PriceCents);
        root.dataset.panel2x2Available = String(panel2x2Available);
        root.dataset.panel2x4VariantId = panel2x4VariantId;
        root.dataset.panel2x4Price = String(panel2x4PriceCents);
        root.dataset.panel2x4Available = String(panel2x4Available);
        updateRoomKitPlan();
      }).catch(function () {
        roomKitProductsLoading = false;
        updatePurchaseTotal();
      });
    }

    function setVariant(button) {
      if (!button) return;
      var available = button.dataset.variantAvailable === 'true';
      currentCoverage = Number(button.dataset.variantCoverage) || 8;
      currentPriceCents = Number(button.dataset.variantPrice) || 0;
      currentVariantTitle = button.dataset.variantTitle || formattedSize(currentCoverage);
      root.dataset.coverage = String(currentCoverage);

      variantButtons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (variantInput) variantInput.value = button.dataset.variantId;
      if (selectedOption) selectedOption.textContent = currentVariantTitle;
      if (mobileTitle) mobileTitle.textContent = formattedSize(currentCoverage) + ' Panel';
      root.querySelectorAll('[data-pdp3-price]').forEach(function (element) {
        element.textContent = money(currentPriceCents);
      });
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      var mobileAdd = root.querySelector('[data-pdp3-mobile-add]');
      if (mobileAdd) mobileAdd.disabled = !available;
      if (quantityInput) quantityInput.value = '1';
      updatePurchaseTotal();
      syncVariantMedia(button);
      updateCalculatorState();
    }

    variantButtons.forEach(function (button) {
      button.disabled = button.dataset.variantAvailable !== 'true';
      button.addEventListener('click', function () { setVariant(button); });
    });

    if (visibleQuantity) {
      visibleQuantity.addEventListener('input', updatePurchaseTotal);
      visibleQuantity.addEventListener('change', updatePurchaseTotal);
    }
    root.querySelectorAll('[data-pdp3-quantity-action]').forEach(function (action) {
      action.addEventListener('click', function () {
        if (!visibleQuantity) return;
        var currentQuantity = Math.max(1, Math.round(Number(visibleQuantity.value) || 1));
        var nextQuantity = currentQuantity + (action.dataset.pdp3QuantityAction === 'plus' ? 1 : -1);
        visibleQuantity.value = String(Math.max(1, Math.min(99, nextQuantity)));
        updatePurchaseTotal();
      });
    });
    controllerOptions.forEach(function (option) {
      option.addEventListener('change', function () {
        if (option.checked) {
          controllerOptions.forEach(function (other) {
            if (other !== option) other.checked = false;
          });
        } else if (!controllerOptions.some(function (item) { return item.checked; })) {
          var noneOption = controllerOptions.find(function (item) { return item.value === 'none'; });
          if (noneOption) noneOption.checked = true;
        }
        updatePurchaseTotal();
      });
    });
    updatePurchaseTotal();

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var quantity = Math.max(1, Math.min(99, Math.round(Number(visibleQuantity && visibleQuantity.value) || 1)));
        var controllerSelected = !controllerOnly && controllerOptions.some(function (option) { return option.value === 'controller' && option.checked; });
        var controllerCount = controllerSelected ? Math.ceil(quantity / controllerCapacity) : 0;
        var primaryItem = { id: variantInput ? variantInput.value : '', quantity: quantity };

        if (roomKit) {
          var kitOption = kitVariantSelect && kitVariantSelect.options[kitVariantSelect.selectedIndex];
          if (!kitOption) return;
          var smallPanelCount = Number(kitOption.dataset.panelSmall) || 0;
          primaryItem.properties = {
            "2' by 4' Panels per kit": String(Number(kitOption.dataset.panelLarge) || 0),
            'Controllers per kit': String(Number(kitOption.dataset.controllerCount) || 0)
          };
          if (smallPanelCount > 0) primaryItem.properties["2' by 2' Panels per kit"] = String(smallPanelCount);
        }

        var items = [primaryItem];
        if (controllerCount > 0) items.push({ id: controllerVariantId, quantity: controllerCount });
        if (!items[0].id || (controllerCount > 0 && !controllerVariantId) || (controllerCount > 0 && !controllerAvailable)) return;

        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Adding...';
        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        }).then(function () {
          window.location.href = cartUrl;
        }).catch(function () {
          if (addButton) addButton.disabled = false;
          if (addLabel) addLabel.textContent = 'Try again';
        });
      });
    }

    // Dawn's native media-gallery owns dragging, loading, thumbnails, and the image modal.
    var nativeGallery = root.querySelector('media-gallery');
    var nativeGalleryStage = root.querySelector('[data-pdp3-gallery-stage], [data-pdp3-native-gallery]') || nativeGallery;
    var nativeGalleryTransitionTimer;

    function showNativeGalleryTransition() {
      if (!nativeGalleryStage) return;
      nativeGalleryStage.classList.remove('is-changing');
      window.clearTimeout(nativeGalleryTransitionTimer);
      void nativeGalleryStage.offsetWidth;
      nativeGalleryStage.classList.add('is-changing');
      nativeGalleryTransitionTimer = window.setTimeout(function () {
        nativeGalleryStage.classList.remove('is-changing');
      }, 220);
    }

    function syncVariantMedia(button) {
      if (!nativeGallery || !button) return;
      var wantedMediaId = button.dataset.variantMediaId || button.dataset.pdp3VariantMediaId;
      if (!wantedMediaId) return;
      var mediaItem = nativeGallery.querySelector('[data-media-id="' + wantedMediaId + '"]');
      if (!mediaItem) mediaItem = nativeGallery.querySelector('[data-media-id$="-' + wantedMediaId + '"]');
      if (!mediaItem) return;

      showNativeGalleryTransition();
      if (typeof nativeGallery.setActiveMedia === 'function') {
        nativeGallery.setActiveMedia(mediaItem.dataset.mediaId, false);
        return;
      }

      var thumbnail = nativeGallery.querySelector('[data-target="' + mediaItem.dataset.mediaId + '"] button');
      if (thumbnail) thumbnail.click();
    }

    if (nativeGallery) {
      var nativeGalleryViewer = nativeGallery.querySelector('slider-component[id^="GalleryViewer"]');
      if (nativeGalleryViewer) nativeGalleryViewer.addEventListener('slideChanged', showNativeGalleryTransition);
      nativeGallery.querySelectorAll('[data-target] button').forEach(function (thumbnail) {
        thumbnail.addEventListener('click', showNativeGalleryTransition);
      });
    }

    function calculateRoomKitPlan(length, width) {
      if (!isFinite(length) || !isFinite(width) || length < 4 || length > 26 || width < 4 || width > 26) return null;
      var rows = Math.floor(length / 2);
      var columns = Math.floor(width / 2);
      var usableLength = rows * 2;
      var usableWidth = columns * 2;
      var offsetX = (width - usableWidth) / 2;
      var offsetY = (length - usableLength) / 2;
      var placements = [];

      function place(x, y, panelWidth, panelLength, size) {
        placements.push({
          x: offsetX + x,
          y: offsetY + y,
          width: panelWidth,
          length: panelLength,
          size: size,
          cut: false
        });
      }

      if (columns % 2 === 0) {
        for (var row = 0; row < rows; row += 1) {
          for (var column = 0; column < columns; column += 2) place(column * 2, row * 2, 4, 2, '2x4');
        }
      } else if (rows % 2 === 0) {
        for (var verticalColumn = 0; verticalColumn < columns; verticalColumn += 1) {
          for (var verticalRow = 0; verticalRow < rows; verticalRow += 2) place(verticalColumn * 2, verticalRow * 2, 2, 4, '2x4');
        }
      } else {
        for (var mixedRow = 0; mixedRow < rows; mixedRow += 1) {
          for (var mixedColumn = 0; mixedColumn < columns - 1; mixedColumn += 2) place(mixedColumn * 2, mixedRow * 2, 4, 2, '2x4');
        }
        for (var edgeRow = 0; edgeRow < rows - 1; edgeRow += 2) place((columns - 1) * 2, edgeRow * 2, 2, 4, '2x4');
        place((columns - 1) * 2, (rows - 1) * 2, 2, 2, '2x2');
      }

      var panel2x2 = placements.filter(function (placement) { return placement.size === '2x2'; }).length;
      var panel2x4 = placements.length - panel2x2;
      var coveredArea = (panel2x4 * 8) + (panel2x2 * 4);
      return {
        length: length,
        width: width,
        roomArea: length * width,
        coveredArea: coveredArea,
        uncoveredArea: Math.max(0, (length * width) - coveredArea),
        panel2x4: panel2x4,
        panel2x2: panel2x2,
        total: panel2x4 + panel2x2,
        controllers: Math.ceil((panel2x4 + panel2x2) / controllerCapacity),
        placements: placements
      };
    }

    function renderRoomKitDiagram(plan) {
      if (!kitDiagram || !plan) return;
      kitDiagram.innerHTML = '';
      var frame = document.createElement('div');
      frame.className = 'pdp3-plan__room-frame';
      frame.style.setProperty('--pdp3-room-ratio', String(plan.width / plan.length));
      var room = document.createElement('div');
      room.className = 'pdp3-plan__room';

      plan.placements.forEach(function (placement) {
        var panel = document.createElement('span');
        panel.className = 'pdp3-plan__panel pdp3-plan__panel--' + placement.size;
        panel.style.left = ((placement.x / plan.width) * 100) + '%';
        panel.style.top = ((placement.y / plan.length) * 100) + '%';
        panel.style.width = ((placement.width / plan.width) * 100) + '%';
        panel.style.height = ((placement.length / plan.length) * 100) + '%';
        panel.title = "Full " + placement.size.replace('x', ' x ') + ' panel';
        panel.setAttribute('aria-hidden', 'true');
        room.appendChild(panel);
      });

      var widthLabel = document.createElement('span');
      widthLabel.className = 'pdp3-plan__dimension pdp3-plan__dimension--width';
      widthLabel.textContent = 'Width ' + plan.width + ' ft';
      var lengthLabel = document.createElement('span');
      lengthLabel.className = 'pdp3-plan__dimension pdp3-plan__dimension--length';
      lengthLabel.textContent = 'Length ' + plan.length + ' ft';
      frame.appendChild(room);
      frame.appendChild(widthLabel);
      frame.appendChild(lengthLabel);
      kitDiagram.appendChild(frame);

      var legend = document.createElement('div');
      legend.className = 'pdp3-plan__legend';
      if (plan.panel2x4) legend.insertAdjacentHTML('beforeend', "<span><i></i>2' by 4' panel</span>");
      if (plan.panel2x2) legend.insertAdjacentHTML('beforeend', "<span class=\"is-2x2\"><i></i>2' by 2' panel</span>");
      if (plan.uncoveredArea) legend.insertAdjacentHTML('beforeend', '<span class="is-open"><i></i>Uncovered edge</span>');
      kitDiagram.appendChild(legend);
      var accessiblePanelSummary = plan.panel2x4 + " 2' by 4' panel" + (plan.panel2x4 === 1 ? '' : 's');
      if (plan.panel2x2) {
        accessiblePanelSummary += ' and ' + plan.panel2x2 + " 2' by 2' panel" + (plan.panel2x2 === 1 ? '' : 's');
      }
      kitDiagram.setAttribute('aria-label', 'Room ' + plan.length + ' feet long by ' + plan.width + ' feet wide with ' + accessiblePanelSummary + '. No panels are cut.');
    }

    function updateRoomKitPlan(source) {
      if (!roomKit) return;
      var option = kitVariantSelect && kitVariantSelect.options[kitVariantSelect.selectedIndex];
      if (!option) return;
      var panelTotal = Number(option.dataset.panelCount) || 0;
      var panel2x4 = Number(option.dataset.panelLarge) || 0;
      var panel2x2 = Number(option.dataset.panelSmall) || 0;
      var controllers = Number(option.dataset.controllerCount) || 1;
      var roomLength = Number(option.dataset.roomLength);
      var roomWidth = Number(option.dataset.roomWidth);
      roomKitPlan = calculateRoomKitPlan(roomLength, roomWidth);
      if (roomKitPlan && (roomKitPlan.panel2x4 !== panel2x4 || roomKitPlan.panel2x2 !== panel2x2)) {
        roomKitPlan = null;
      }
      if (roomKitPlan) {
        roomKitPlan.controllers = controllers;
        renderRoomKitDiagram(roomKitPlan);
      } else if (kitDiagram) {
        kitDiagram.innerHTML = '<p class="pdp3-plan__diagram-summary">Layout unavailable for this room size.</p>';
        kitDiagram.setAttribute('aria-label', 'Layout unavailable for this room size.');
      }
      if (kitPanelTotal) kitPanelTotal.textContent = String(panelTotal);
      if (kitControllerCount) {
        kitControllerCount.textContent = String(controllers);
        var controllerText = kitControllerCount.parentElement;
        if (controllerText) controllerText.lastChild.textContent = controllers === 1 ? ' controller' : ' controllers';
      }
      if (kitPanelDetail) {
        kitPanelDetail.textContent = panel2x4 + " full 2' by 4' panel" + (panel2x4 === 1 ? '' : 's') +
          (panel2x2 ? ' + ' + panel2x2 + " full 2' by 2' panel" + (panel2x2 === 1 ? '' : 's') : '') +
          '. No cutting or extra allowance.';
      }
      updatePurchaseTotal();

      if (source === 'user') {
        trackBuilderStarted('room_kit');
        publishTracking('starlight:room_kit_configured', {
          builder_type: 'room_kit',
          variant_id: String(option.value),
          room_length: roomLength,
          room_width: roomWidth,
          panel_count: panelTotal,
          panel_2x4_count: panel2x4,
          panel_2x2_count: panel2x2,
          controller_count: controllers,
          value: currentPriceCents / 100,
          currency: currency
        }, window.location.pathname + ':room_kit:' + String(option.value));
      }
    }

    if (kitVariantSelect) {
      kitVariantSelect.addEventListener('change', function () { updateRoomKitPlan('user'); });
    }

    var miniWidth = root.querySelector('[data-pdp3-mini-width]');
    var miniLength = root.querySelector('[data-pdp3-mini-length]');
    var miniResult = root.querySelector('[data-pdp3-mini-result]');
    var calcLength = root.querySelector('[data-pdp3-calc-length]');
    var calcWidth = root.querySelector('[data-pdp3-calc-width]');
    var calcCeiling = root.querySelector('[data-pdp3-calc-ceiling]');
    var calcCoverage = root.querySelector('[data-pdp3-calc-coverage]');
    var planArea = root.querySelector('[data-pdp3-plan-area]');
    var planPanels = root.querySelector('[data-pdp3-plan-panels]');
    var planSize = root.querySelector('[data-pdp3-plan-size]');
    var planCoverage = root.querySelector('[data-pdp3-plan-coverage]');
    var planTime = root.querySelector('[data-pdp3-plan-time]');
    var planPrice = root.querySelector('[data-pdp3-plan-price]');
    var planItems = root.querySelector('[data-pdp3-plan-items]');
    var planMaterial = root.querySelector('[data-pdp3-plan-material]');
    var planWaste = root.querySelector('[data-pdp3-plan-waste]');
    var planNote = root.querySelector('[data-pdp3-plan-note]');
    var planDiagram = root.querySelector('[data-pdp3-plan-diagram]');
    var emailPlan = root.querySelector('[data-pdp3-email-plan]');
    var addPlan = root.querySelector('[data-pdp3-add-plan]');
    var dealerPlanTarget = root.querySelector('[data-pdp3-dealer-plan-target]');
    var planController = root.querySelector('[data-pdp3-plan-controllers], [data-pdp3-plan-controller]');
    var recommendedControllers = 0;
    var calculatorState = {
      length: calcLength ? calcLength.value : (miniLength ? miniLength.value : ''),
      width: calcWidth ? calcWidth.value : (miniWidth ? miniWidth.value : '')
    };

    if (!planController) {
      Array.prototype.slice.call(root.querySelectorAll('.pdp3-plan__result dt')).some(function (term) {
        if (term.textContent.trim().toLowerCase() !== 'controller') return false;
        planController = term.nextElementSibling;
        return true;
      });
    }

    function finiteNumber(value) {
      var number = Number(value);
      return typeof number === 'number' && isFinite(number) ? number : null;
    }

    function inputBounds(input) {
      var min = finiteNumber(input && input.getAttribute('min'));
      var max = finiteNumber(input && input.getAttribute('max'));
      return {
        min: min === null ? 1 : min,
        max: max === null ? 100 : max
      };
    }

    function validateDimension(value, input) {
      var number = finiteNumber(value);
      var bounds = inputBounds(input);
      return number !== null && number >= bounds.min && number <= bounds.max ? number : null;
    }

    function coverageRatio() {
      var ratio = finiteNumber(calcCoverage && calcCoverage.value);
      return ratio !== null && ratio > 0 && ratio <= 1 ? ratio : 1;
    }

    function pluralize(count, singular, plural) {
      return String(count) + ' ' + (count === 1 ? singular : (plural || singular + 's'));
    }

    function controllerSummary(count) {
      return pluralize(count, 'controller');
    }

    function formatArea(area) {
      return area.toFixed(Math.round(area) === area ? 0 : 1) + ' sq. ft.';
    }

    function setInputValue(input, value) {
      if (input && input.value !== value) input.value = value;
    }

    function syncCalculatorInputs() {
      setInputValue(calcLength, calculatorState.length);
      setInputValue(calcWidth, calculatorState.width);
      setInputValue(miniLength, calculatorState.length);
      setInputValue(miniWidth, calculatorState.width);
    }

    var layoutEpsilon = 0.0001;

    function nearlyWhole(value) {
      return Math.abs(value - Math.round(value)) < layoutEpsilon;
    }

    function wholeFloor(value) {
      return nearlyWhole(value) ? Math.round(value) : Math.floor(value);
    }

    function wholeCeil(value) {
      return nearlyWhole(value) ? Math.round(value) : Math.ceil(value);
    }

    function emptyPanelCounts() {
      return {
        full2x2: 0,
        cut2x2: 0,
        full2x4: 0,
        cut2x4: 0
      };
    }

    function totalForCounts(counts) {
      return counts.full2x2 + counts.cut2x2 + counts.full2x4 + counts.cut2x4;
    }

    function cutTotalForCounts(counts) {
      return counts.cut2x2 + counts.cut2x4;
    }

    function fullTotalForCounts(counts) {
      return counts.full2x2 + counts.full2x4;
    }

    function priceForCounts(counts) {
      return totalForCounts(counts) * currentPriceCents;
    }

    function materialAreaForCounts(counts) {
      return ((counts.full2x2 + counts.cut2x2) * 4) + ((counts.full2x4 + counts.cut2x4) * 8);
    }

    function nearlyEqual(first, second) {
      return Math.abs(first - second) < layoutEpsilon;
    }

    function combinePanelCounts(first, second) {
      return {
        full2x2: first.full2x2 + second.full2x2,
        cut2x2: first.cut2x2 + second.cut2x2,
        full2x4: first.full2x4 + second.full2x4,
        cut2x4: first.cut2x4 + second.cut2x4
      };
    }

    function fullCandidateFromCounts(length, width, counts, placements) {
      var materialArea = materialAreaForCounts(counts);
      return {
        mode: 'full',
        roomArea: length * width,
        coveredArea: length * width,
        materialArea: materialArea,
        wasteArea: Math.max(0, materialArea - (length * width)),
        counts: counts,
        placements: placements,
        total: totalForCounts(counts),
        full: fullTotalForCounts(counts),
        cut: cutTotalForCounts(counts),
        price: priceForCounts(counts),
        orientation: 'optimized'
      };
    }

    function buildOptimizedFullCandidate(length, width) {
      var memo = {};
      var splitSizes = currentCoverage === 4 ? [2] : [2, 4];

      function directCandidate(rectLength, rectWidth, size) {
        var is2x2 = size === '2x2';
        var fits = is2x2
          ? rectWidth <= 2 + layoutEpsilon && rectLength <= 2 + layoutEpsilon
          : (rectWidth <= 4 + layoutEpsilon && rectLength <= 2 + layoutEpsilon) ||
            (rectWidth <= 2 + layoutEpsilon && rectLength <= 4 + layoutEpsilon);
        if (!fits) return null;

        var isFull = is2x2
          ? nearlyEqual(rectWidth, 2) && nearlyEqual(rectLength, 2)
          : (nearlyEqual(rectWidth, 4) && nearlyEqual(rectLength, 2)) ||
            (nearlyEqual(rectWidth, 2) && nearlyEqual(rectLength, 4));
        var counts = emptyPanelCounts();
        counts[(isFull ? 'full' : 'cut') + size] = 1;
        return fullCandidateFromCounts(rectLength, rectWidth, counts, [{
          x: 0,
          y: 0,
          width: rectWidth,
          length: rectLength,
          size: size,
          cut: !isFull
        }]);
      }

      function mergeCandidates(rectLength, rectWidth, first, second, axis, offset) {
        if (!first || !second) return null;
        var shiftedPlacements = second.placements.map(function (placement) {
          return {
            x: placement.x + (axis === 'x' ? offset : 0),
            y: placement.y + (axis === 'y' ? offset : 0),
            width: placement.width,
            length: placement.length,
            size: placement.size,
            cut: placement.cut
          };
        });
        return fullCandidateFromCounts(
          rectLength,
          rectWidth,
          combinePanelCounts(first.counts, second.counts),
          first.placements.concat(shiftedPlacements)
        );
      }

      function solveRectangle(rectLength, rectWidth) {
        var key = rectLength.toFixed(4) + 'x' + rectWidth.toFixed(4);
        if (memo[key]) return memo[key];
        var best = currentCoverage === 4
          ? directCandidate(rectLength, rectWidth, '2x2')
          : directCandidate(rectLength, rectWidth, '2x4');

        splitSizes.forEach(function (split) {
          if (split < rectWidth - layoutEpsilon) {
            var left = solveRectangle(rectLength, split);
            var right = solveRectangle(rectLength, rectWidth - split);
            var vertical = mergeCandidates(rectLength, rectWidth, left, right, 'x', split);
            if (isBetterFullCandidate(vertical, best)) best = vertical;
          }
          if (split < rectLength - layoutEpsilon) {
            var top = solveRectangle(split, rectWidth);
            var bottom = solveRectangle(rectLength - split, rectWidth);
            var horizontal = mergeCandidates(rectLength, rectWidth, top, bottom, 'y', split);
            if (isBetterFullCandidate(horizontal, best)) best = horizontal;
          }
        });

        memo[key] = best;
        return best;
      }

      return solveRectangle(length, width);
    }

    function isBetterFullCandidate(candidate, currentBest) {
      if (!candidate) return false;
      if (!currentBest) return true;
      if (candidate.price !== currentBest.price) return candidate.price < currentBest.price;
      if (Math.abs(candidate.wasteArea - currentBest.wasteArea) > layoutEpsilon) return candidate.wasteArea < currentBest.wasteArea;
      if (candidate.total !== currentBest.total) return candidate.total < currentBest.total;
      if (candidate.cut !== currentBest.cut) return candidate.cut < currentBest.cut;
      if (candidate.counts.cut2x4 !== currentBest.counts.cut2x4) return candidate.counts.cut2x4 < currentBest.counts.cut2x4;
      return candidate.orientation === '4x2';
    }

    function buildFeatureCandidate(length, width, ratio, panelWidth, panelLength, size) {
      var maxRows = wholeFloor(length / panelLength);
      var maxColumns = wholeFloor(width / panelWidth);
      if (maxRows < 1 || maxColumns < 1) return null;

      var panelArea = panelWidth * panelLength;
      var targetCount = Math.ceil((length * width * ratio) / panelArea);
      var roomRatio = width / length;
      var best = null;

      for (var rows = 1; rows <= maxRows; rows += 1) {
        for (var columns = 1; columns <= maxColumns; columns += 1) {
          var count = rows * columns;
          var meetsTarget = count >= targetCount;
          var layoutRatio = (columns * panelWidth) / (rows * panelLength);
          var candidate = {
            rows: rows,
            columns: columns,
            count: count,
            meetsTarget: meetsTarget,
            difference: Math.abs(count - targetCount),
            ratioDifference: Math.abs(Math.log(layoutRatio / roomRatio))
          };
          if (!best ||
              (candidate.meetsTarget && !best.meetsTarget) ||
              (candidate.meetsTarget === best.meetsTarget && candidate.difference < best.difference) ||
              (candidate.meetsTarget === best.meetsTarget && candidate.difference === best.difference && candidate.ratioDifference < best.ratioDifference)) {
            best = candidate;
          }
        }
      }

      if (!best) return null;
      var layoutWidth = best.columns * panelWidth;
      var layoutLength = best.rows * panelLength;
      var startX = (width - layoutWidth) / 2;
      var startY = (length - layoutLength) / 2;
      var placements = [];
      for (var row = 0; row < best.rows; row += 1) {
        for (var column = 0; column < best.columns; column += 1) {
          placements.push({
            x: startX + (column * panelWidth),
            y: startY + (row * panelLength),
            width: panelWidth,
            length: panelLength,
            size: size,
            cut: false
          });
        }
      }

      var counts = emptyPanelCounts();
      counts['full' + size] = best.count;
      var materialArea = materialAreaForCounts(counts);
      return {
        mode: 'feature',
        roomArea: length * width,
        targetArea: length * width * ratio,
        coveredArea: materialArea,
        materialArea: materialArea,
        wasteArea: 0,
        counts: counts,
        placements: placements,
        total: totalForCounts(counts),
        full: fullTotalForCounts(counts),
        cut: 0,
        price: priceForCounts(counts),
        orientation: panelWidth + 'x' + panelLength,
        targetReached: best.meetsTarget
      };
    }

    function isBetterFeatureCandidate(candidate, currentBest) {
      if (!candidate) return false;
      if (!currentBest) return true;
      if (candidate.targetReached && !currentBest.targetReached) return true;
      if (candidate.targetReached !== currentBest.targetReached) return false;
      var candidateDifference = Math.abs(candidate.coveredArea - candidate.targetArea);
      var currentDifference = Math.abs(currentBest.coveredArea - currentBest.targetArea);
      if (Math.abs(candidateDifference - currentDifference) > layoutEpsilon) return candidateDifference < currentDifference;
      if (candidate.price !== currentBest.price) return candidate.price < currentBest.price;
      return candidate.orientation === '4x2';
    }

    function calculateLayout(length, width, ratio) {
      if (ratio === 1) return buildOptimizedFullCandidate(length, width);

      var orientations = currentCoverage === 4
        ? [{ width: 2, length: 2, size: '2x2' }]
        : [{ width: 4, length: 2, size: '2x4' }, { width: 2, length: 4, size: '2x4' }];
      var best = null;

      orientations.forEach(function (orientation) {
        var candidate = buildFeatureCandidate(length, width, ratio, orientation.width, orientation.length, orientation.size);
        if (isBetterFeatureCandidate(candidate, best)) best = candidate;
      });

      return best || {
        mode: ratio === 1 ? 'full' : 'feature',
        roomArea: length * width,
        targetArea: length * width * ratio,
        coveredArea: 0,
        materialArea: 0,
        wasteArea: 0,
        counts: emptyPanelCounts(),
        placements: [],
        total: 0,
        full: 0,
        cut: 0,
        price: 0,
        targetReached: false
      };
    }

    function calculateControllerCount(panelCount) {
      return panelCount > 0 ? Math.ceil(panelCount / controllerCapacity) : 0;
    }

    function installTimeLabel(count) {
      var minutes = 25 + (count * 9);
      if (minutes < 60) return 'About ' + minutes + ' minutes';
      var hours = Math.ceil(minutes / 30) / 2;
      return 'About ' + hours + (hours === 1 ? ' hour' : ' hours');
    }

    function ceilingNote(type) {
      if (type === 'drywall') return 'Use the recommended solid-ceiling mounting method. Contact support before ordering.';
      if (type === 'frame') return 'Designed around the recommended mounting frame. Confirm finished dimensions before ordering.';
      return 'Fits a standard drop ceiling. Confirm grid dimensions before ordering.';
    }

    function renderDiagram(layout, length, width, controllerCount) {
      if (!planDiagram) return;
      planDiagram.innerHTML = '';
      planDiagram.dataset.controllerCount = String(controllerCount || 0);

      if (!layout || !layout.total) {
        var emptyMessage = document.createElement('p');
        emptyMessage.className = 'pdp3-plan__diagram-summary';
        emptyMessage.textContent = layout && layout.mode === 'feature'
          ? 'No whole panel fits inside these room dimensions.'
          : 'Enter valid room dimensions to see a suggested layout.';
        planDiagram.appendChild(emptyMessage);
        planDiagram.setAttribute('aria-label', emptyMessage.textContent);
        return;
      }

      var frame = document.createElement('div');
      frame.className = 'pdp3-plan__room-frame';
      frame.style.setProperty('--pdp3-room-ratio', String(width / length));
      var room = document.createElement('div');
      room.className = 'pdp3-plan__room';

      layout.placements.forEach(function (placement) {
        var panel = document.createElement('span');
        panel.className = 'pdp3-plan__panel pdp3-plan__panel--' + placement.size + (placement.cut ? ' pdp3-plan__panel--cut' : '');
        panel.style.left = ((placement.x / width) * 100) + '%';
        panel.style.top = ((placement.y / length) * 100) + '%';
        panel.style.width = ((placement.width / width) * 100) + '%';
        panel.style.height = ((placement.length / length) * 100) + '%';
        panel.title = (placement.cut ? 'Cut-to-fit ' : 'Full ') + placement.size.replace('x', ' x ') + ' panel';
        panel.setAttribute('aria-hidden', 'true');
        room.appendChild(panel);
      });

      var widthLabel = document.createElement('span');
      widthLabel.className = 'pdp3-plan__dimension pdp3-plan__dimension--width';
      widthLabel.textContent = 'Width ' + width + ' ft';
      var lengthLabel = document.createElement('span');
      lengthLabel.className = 'pdp3-plan__dimension pdp3-plan__dimension--length';
      lengthLabel.textContent = 'Length ' + length + ' ft';
      frame.appendChild(room);
      frame.appendChild(widthLabel);
      frame.appendChild(lengthLabel);
      planDiagram.appendChild(frame);

      var legend = document.createElement('div');
      legend.className = 'pdp3-plan__legend';
      if (layout.counts.full2x4 || layout.counts.cut2x4) legend.insertAdjacentHTML('beforeend', "<span><i></i>2' by 4' panel</span>");
      if (layout.counts.full2x2 || layout.counts.cut2x2) legend.insertAdjacentHTML('beforeend', "<span class=\"is-2x2\"><i></i>2' by 2' panel</span>");
      if (layout.cut) legend.insertAdjacentHTML('beforeend', '<span class="is-cut"><i></i>Cut-to-fit panel</span>');
      planDiagram.appendChild(legend);
      planDiagram.setAttribute('aria-label', 'Room ' + length + ' feet long by ' + width + ' feet wide, with ' + layout.total + ' panels, including ' + layout.cut + ' cut-to-fit panels');
    }

    function updatePlanAction(valid) {
      if (!addPlan) return;
      addPlan.disabled = !valid;
      addPlan.setAttribute('aria-disabled', valid ? 'false' : 'true');
    }

    function sizeCount(counts, size) {
      return size === '2x2'
        ? counts.full2x2 + counts.cut2x2
        : counts.full2x4 + counts.cut2x4;
    }

    function panelBreakdown(counts, type) {
      var parts = [];
      var count2x4 = type === 'full' ? counts.full2x4 : type === 'cut' ? counts.cut2x4 : sizeCount(counts, '2x4');
      var count2x2 = type === 'full' ? counts.full2x2 : type === 'cut' ? counts.cut2x2 : sizeCount(counts, '2x2');
      if (count2x4) parts.push(count2x4 + " 2' by 4' panels");
      if (count2x2) parts.push(count2x2 + " 2' by 2' panels");
      return parts.length ? parts.join(' + ') : 'None';
    }

    function renderPanelOrderList(counts, message) {
      if (!planItems) return;
      planItems.innerHTML = '';

      if (!counts || !totalForCounts(counts)) {
        var emptyItem = document.createElement('li');
        emptyItem.className = 'pdp3-plan__panel-list-empty';
        emptyItem.textContent = message || 'Enter room dimensions to see your panel list.';
        planItems.appendChild(emptyItem);
        return;
      }

      [
        { key: 'full2x4', label: "Full 2' by 4' panels", note: 'Install without cutting', size: '2x4', cut: false },
        { key: 'cut2x4', label: "Cut-to-fit 2' by 4' panels", note: 'Trim each panel once; discard the offcut', size: '2x4', cut: true },
        { key: 'full2x2', label: "Full 2' by 2' panels", note: 'Install without cutting', size: '2x2', cut: false },
        { key: 'cut2x2', label: "Cut-to-fit 2' by 2' panels", note: 'Trim each panel once; discard the offcut', size: '2x2', cut: true }
      ].forEach(function (item) {
        var count = counts[item.key];
        if (!count) return;

        var row = document.createElement('li');
        var description = document.createElement('span');
        var swatch = document.createElement('i');
        var copy = document.createElement('span');
        var label = document.createElement('strong');
        var note = document.createElement('small');
        var value = document.createElement('b');

        swatch.className = 'pdp3-plan__item-swatch is-' + item.size + (item.cut ? ' is-cut' : '');
        label.textContent = item.label;
        note.textContent = item.note;
        value.textContent = String(count);
        copy.appendChild(label);
        copy.appendChild(note);
        description.appendChild(swatch);
        description.appendChild(copy);
        row.appendChild(description);
        row.appendChild(value);
        planItems.appendChild(row);
      });
    }

    function updateEmailPlan(valid, length, width, layout) {
      if (!emailPlan) return;
      var address = (emailPlan.getAttribute('href') || 'mailto:').split('?')[0];
      if (!valid || !layout) {
        emailPlan.href = address;
        return;
      }
      var subject = 'My Starlight Ceiling room plan';
      var body = [
        'Room: ' + length + ' ft x ' + width + ' ft',
        'Recommended: ' + panelBreakdown(layout.counts),
        'Full panels: ' + panelBreakdown(layout.counts, 'full'),
        'Cut-to-fit panels: ' + panelBreakdown(layout.counts, 'cut'),
        'Exact covered area: ' + layout.coveredArea.toFixed(1) + ' sq. ft.',
        'Purchased panel material: ' + layout.materialArea.toFixed(1) + ' sq. ft.',
        'Discarded offcuts: ' + layout.wasteArea.toFixed(1) + ' sq. ft. (cannot be reused)',
        'Controllers: ' + controllerSummary(recommendedControllers) + ' (up to ' + controllerCapacity + ' panels each)',
        'Estimated panel subtotal: ' + money(layout.price)
      ].join('\n');
      emailPlan.href = address + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    function updateCalculatorState(source, trackCompletion) {
      if (source) trackBuilderStarted('panel_planner');
      if (source === 'mini') {
        calculatorState.length = miniLength ? miniLength.value : calculatorState.length;
        calculatorState.width = miniWidth ? miniWidth.value : calculatorState.width;
      } else if (source === 'full') {
        calculatorState.length = calcLength ? calcLength.value : calculatorState.length;
        calculatorState.width = calcWidth ? calcWidth.value : calculatorState.width;
      }
      syncCalculatorInputs();

      var length = validateDimension(calculatorState.length, calcLength || miniLength);
      var width = validateDimension(calculatorState.width, calcWidth || miniWidth);
      var ratio = coverageRatio();
      var valid = length !== null && width !== null;
      var invalidMessage = 'Enter room dimensions between 1 and 100 ft.';

      if (!valid) {
        recommendedPanels = 0;
        recommendedControllers = 0;
        if (miniResult) {
          miniResult.setAttribute('aria-live', 'polite');
          miniResult.textContent = invalidMessage;
        }
        if (planArea) planArea.textContent = '--';
        if (planPanels) planPanels.textContent = '--';
        if (planSize) planSize.textContent = 'panels to order';
        if (planCoverage) planCoverage.textContent = '--';
        if (planTime) planTime.textContent = '--';
        if (planPrice) planPrice.textContent = '--';
        if (planMaterial) planMaterial.textContent = '--';
        if (planWaste) planWaste.textContent = '--';
        if (planController) planController.textContent = '--';
        renderPanelOrderList(null, invalidMessage);
        if (planNote) planNote.textContent = invalidMessage;
        renderDiagram(null, 0, 0, 0);
        updatePlanAction(false);
        updateEmailPlan(false);
        return;
      }

      var totalArea = length * width;
      var layout = calculateLayout(length, width, ratio);
      recommendedPanels = layout.total;
      recommendedControllers = calculateControllerCount(recommendedPanels);

      if (!recommendedPanels) {
        if (miniResult) miniResult.textContent = 'No whole panel fits inside these room dimensions.';
        if (planArea) planArea.textContent = length + ' ft x ' + width + ' ft · ' + formatArea(totalArea);
        if (planPanels) planPanels.textContent = '0';
        if (planSize) planSize.textContent = 'panels to order';
        if (planCoverage) planCoverage.textContent = '0 sq. ft.';
        if (planTime) planTime.textContent = '--';
        if (planPrice) planPrice.textContent = money(0);
        if (planController) planController.textContent = 'None';
        if (planMaterial) planMaterial.textContent = '0 sq. ft.';
        if (planWaste) planWaste.textContent = '0 sq. ft.';
        renderPanelOrderList(null, 'No whole panel fits inside these room dimensions.');
        if (planNote) planNote.textContent = 'Feature areas use whole panels only. Increase the room dimensions or choose Full ceiling for a cut-to-fit plan.';
        renderDiagram(layout, length, width, 0);
        updatePlanAction(false);
        updateEmailPlan(false);
        return;
      }

      if (miniResult) {
        miniResult.setAttribute('aria-live', 'polite');
        miniResult.textContent = 'You need ' + pluralize(recommendedPanels, 'panel') + ' and ' + controllerSummary(recommendedControllers) + '. ' +
          (layout.cut ? pluralize(layout.cut, 'panel') + ' will be trimmed to fit.' : 'No panel cutting is required.');
      }
      if (planArea) planArea.textContent = length + ' ft x ' + width + ' ft · ' + formatArea(totalArea);
      if (planPanels) planPanels.textContent = String(recommendedPanels);
      if (planSize) planSize.textContent = 'panels to order';
      if (planCoverage) planCoverage.textContent = formatArea(layout.coveredArea);
      if (planTime) planTime.textContent = installTimeLabel(recommendedPanels);
      if (planPrice) planPrice.textContent = money(layout.price);
      if (planController) planController.textContent = controllerSummary(recommendedControllers);
      if (planMaterial) planMaterial.textContent = formatArea(layout.materialArea);
      if (planWaste) planWaste.textContent = formatArea(layout.wasteArea);
      renderPanelOrderList(layout.counts);
      if (planNote) {
        if (layout.mode === 'full') {
          planNote.textContent = (layout.cut
            ? pluralize(layout.cut, 'panel') + ' require edge cuts. Cut-off material cannot be reused because each panel has one control unit. '
            : 'No panel cutting is required. ') + ceilingNote(calcCeiling ? calcCeiling.value : 'drop');
        } else {
          var actualRatio = totalArea ? Math.round((layout.coveredArea / totalArea) * 100) : 0;
          planNote.textContent = 'Whole-panel feature layout with no cutting. Actual coverage: ' + actualRatio + '%. ' + ceilingNote(calcCeiling ? calcCeiling.value : 'drop');
        }
      }
      renderDiagram(layout, length, width, recommendedControllers);
      updatePlanAction(currentAvailable);
      updateEmailPlan(true, length, width, layout);

      if (trackCompletion) {
        var planSignature = [length, width, ratio, layout.mode, recommendedPanels, recommendedControllers].join(':');
        publishTracking('starlight:room_plan_generated', {
          builder_type: 'panel_planner',
          room_length: length,
          room_width: width,
          coverage_ratio: ratio,
          layout_mode: layout.mode,
          panel_count: recommendedPanels,
          controller_count: recommendedControllers,
          value: layout.price / 100,
          currency: currency
        }, window.location.pathname + ':room_plan:' + planSignature);
      }
    }

    [miniWidth, miniLength].forEach(function (control) {
      if (control) control.addEventListener('input', function () { updateCalculatorState('mini', false); });
      if (control) control.addEventListener('change', function () { updateCalculatorState('mini', true); });
    });
    [calcLength, calcWidth].forEach(function (control) {
      if (control) control.addEventListener('input', function () { updateCalculatorState('full', false); });
      if (control) control.addEventListener('change', function () { updateCalculatorState('full', true); });
    });
    [calcCeiling, calcCoverage].forEach(function (control) {
      if (control) control.addEventListener('input', function () { updateCalculatorState('options', false); });
      if (control) control.addEventListener('change', function () { updateCalculatorState('options', true); });
    });

    if (addPlan) {
      addPlan.addEventListener('click', function () {
        if (!recommendedPanels) return;
        if (visibleQuantity) visibleQuantity.value = String(recommendedPanels);
        if (quantityInput) quantityInput.value = String(recommendedPanels);
        updatePurchaseTotal();
        publishTracking('starlight:room_plan_applied', {
          builder_type: 'panel_planner',
          room_length: Number(calculatorState.length),
          room_width: Number(calculatorState.width),
          panel_count: recommendedPanels,
          controller_count: recommendedControllers
        }, window.location.pathname + ':room_plan_applied:' + [calculatorState.length, calculatorState.width, recommendedPanels, recommendedControllers].join(':'));
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else if (dealerPlanTarget) {
          var target = document.querySelector(dealerPlanTarget.dataset.pdp3DealerPlanTarget);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (addLabel) addLabel.textContent = 'Add ' + recommendedPanels + ' panels';
      });
    }

    var initialVariant = variantButtons.find(function (button) { return button.classList.contains('is-active'); });
    if (roomKit) {
      updateRoomKitPlan();
    }
    else if (initialVariant) setVariant(initialVariant);
    else updateCalculatorState();

    var beforeRange = root.querySelector('[data-pdp3-before-range]');
    var afterLayer = root.querySelector('[data-pdp3-after]');
    var beforeLine = root.querySelector('[data-pdp3-before-line]');
    if (beforeRange && afterLayer && beforeLine) {
      beforeRange.addEventListener('input', function () {
        var value = beforeRange.value + '%';
        afterLayer.style.width = value;
        beforeLine.style.left = value;
      });
    }

    // Match the Gallery's masonry behavior by placing each room card in the shortest column.
    var roomGrid = root.querySelector('.pdp3-room-tabs__grid');
    if (roomGrid && roomGrid.dataset.pdp3RoomLayoutReady !== 'true') {
      var roomCards = Array.prototype.slice.call(roomGrid.children).filter(function (element) {
        return element.classList.contains('pdp3-room-tabs__card');
      });
      var roomColumnCount = 0;
      var roomResizeTimer = null;

      function getRoomColumnCount() {
        if (window.innerWidth < 768) return 1;
        if (window.innerWidth < 990) return 3;
        return 4;
      }

      function buildRoomColumns() {
        var columnCount = getRoomColumnCount();
        if (columnCount === roomColumnCount && roomGrid.querySelector('.pdp3-room-tabs__column')) return;
        roomColumnCount = columnCount;

        var gap = columnCount === 2 ? 10 : columnCount === 3 ? 12 : 16;
        var cardWidth = Math.max(1, (roomGrid.clientWidth - (columnCount - 1) * gap) / columnCount);
        var columns = Array.from({ length: columnCount }, function () {
          var column = document.createElement('div');
          column.className = 'pdp3-room-tabs__column';
          column.setAttribute('role', 'presentation');
          return column;
        });
        var heights = columns.map(function () { return 0; });

        var weightedCards = roomCards.map(function (card, index) {
          var ratio = card.classList.contains('pdp3-room-tabs__card--tall') ? (4 / 5) : (4 / 3);
          return { card: card, height: cardWidth / ratio, index: index };
        }).sort(function (left, right) {
          return right.height - left.height || left.index - right.index;
        });

        weightedCards.forEach(function (entry) {
          var card = entry.card;
          var shortestColumn = heights.indexOf(Math.min.apply(Math, heights));
          heights[shortestColumn] += entry.height + (columnCount === 2 ? 12 : columnCount === 3 ? 16 : 20);
          columns[shortestColumn].appendChild(card);
        });

        roomGrid.style.setProperty('--pdp3-room-columns', String(columnCount));
        roomGrid.replaceChildren.apply(roomGrid, columns);
      }

      buildRoomColumns();
      window.addEventListener('resize', function () {
        window.clearTimeout(roomResizeTimer);
        roomResizeTimer = window.setTimeout(buildRoomColumns, 120);
      });
      roomGrid.dataset.pdp3RoomLayoutReady = 'true';
    }

    var reviewFilters = Array.prototype.slice.call(root.querySelectorAll('[data-pdp3-review-filter]'));
    var reviewCards = Array.prototype.slice.call(root.querySelectorAll('[data-pdp3-review-card]'));
    reviewFilters.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.dataset.pdp3ReviewFilter;
        reviewFilters.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        reviewCards.forEach(function (card) {
          card.hidden = filter !== 'all' && card.dataset.room !== filter;
        });
      });
    });

    var reviewLightbox = root.querySelector('[data-pdp3-review-lightbox]');
    var reviewLightboxDialog = reviewLightbox && reviewLightbox.querySelector('.pdp3-review-lightbox__dialog');
    var reviewLightboxImage = reviewLightbox && reviewLightbox.querySelector('[data-pdp3-review-image]');
    var reviewLightboxTitle = reviewLightbox && reviewLightbox.querySelector('[data-pdp3-review-title]');
    var reviewLightboxSubtitle = reviewLightbox && reviewLightbox.querySelector('[data-pdp3-review-subtitle]');
    var reviewLightboxClose = reviewLightbox && reviewLightbox.querySelector('[data-pdp3-review-close]');
    var reviewLightboxTrigger = null;

    function closeReviewLightbox() {
      if (!reviewLightbox || reviewLightbox.hidden) return;
      reviewLightbox.hidden = true;
      reviewLightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp3-lightbox-open');
      if (reviewLightboxTrigger) reviewLightboxTrigger.focus();
    }

    root.querySelectorAll('[data-pdp3-review-open], [data-pdp3-room-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (!reviewLightbox) return;
        var card = trigger.closest('[data-pdp3-review-card], [data-pdp3-room-card]');
        var image = card && card.querySelector('img');
        var title = card && card.querySelector('figcaption strong');
        var subtitle = card && card.querySelector('figcaption span');
        if (!image || !reviewLightboxImage) return;
        reviewLightboxTrigger = trigger;
        reviewLightboxImage.src = image.currentSrc || image.src;
        reviewLightboxImage.alt = image.alt || '';
        if (reviewLightboxTitle) reviewLightboxTitle.textContent = title ? title.textContent : '';
        if (reviewLightboxSubtitle) reviewLightboxSubtitle.textContent = subtitle ? subtitle.textContent : '';
        reviewLightbox.hidden = false;
        reviewLightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('pdp3-lightbox-open');
        if (reviewLightboxClose) reviewLightboxClose.focus();
      });
    });

    if (reviewLightboxClose) reviewLightboxClose.addEventListener('click', closeReviewLightbox);
    if (reviewLightbox) {
      reviewLightbox.addEventListener('click', function (event) {
        if (event.target === reviewLightbox) closeReviewLightbox();
      });
      reviewLightbox.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeReviewLightbox();
        if (event.key === 'Tab' && reviewLightboxDialog) {
          var focusable = Array.prototype.slice.call(reviewLightboxDialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')).filter(function (element) {
            return !element.disabled;
          });
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
    }

    var mobileAdd = root.querySelector('[data-pdp3-mobile-add]');
    if (mobileAdd && addButton) mobileAdd.addEventListener('click', function () { addButton.click(); });
    var scrollBuy = root.querySelector('[data-pdp3-scroll-buy]');
    if (scrollBuy) scrollBuy.addEventListener('click', function () {
      root.querySelector('.pdp3-buy').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('.pdp3-reveal').forEach(function (element) { observer.observe(element); });
    } else {
      root.querySelectorAll('.pdp3-reveal').forEach(function (element) { element.classList.add('is-visible'); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pdp3]').forEach(initPdp);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
